import { TYPES } from "./types";
import { listingService } from "../services"; 
import { setFlag } from "./miscAction";
import { CONFIGS } from "../configs";
import { orderService } from '../services/orderService';

export const getOrders = (params) => async (dispatch) => {
  try {
    const response = await orderService.getOrders(params);
    dispatch({
      type: TYPES.ACTION_GET_ORDERS_SUCCESS,
      payload: {
        orders: response.orders || [],
        totalCount: response.totalCount || 0
      }
    });
    return response;
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_GET_ORDERS_FAIL,
      payload: error.response?.data || error.message
    });
    throw error;
  }
};

export const updateOrders = (orders) => async (dispatch) => {
  try {
    const response = await orderService.updateOrders(orders);
    dispatch({
      type: TYPES.ACTION_UPDATE_ORDERS_SUCCESS,
      payload: response.data.orders
    });
    return response;
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_UPDATE_ORDERS_FAIL,
      payload: error.response?.data || error.message
    });
    throw error;
  }
};

export const getSaleTeamStatus = (params) => async (dispatch) => {
  try {
    const response = await orderService.getSaleTeamStatus(params);
    dispatch({
      type: TYPES.ACTION_GET_SALE_TEAM_STATUS_SUCCESS,
      payload: response
    });
    return response;
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_GET_SALE_TEAM_STATUS_FAIL,
      payload: error.response?.data || error.message
    });
    throw error;
  }
};

export const getFulfillTeamStat = (params) => async (dispatch) => {
  try {
    const response = await orderService.getFulfillTeamStat(params);
    dispatch({
      type: TYPES.ACTION_GET_FULFILL_TEAM_STAT_SUCCESS,
      payload: response
    });
    return response;
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_GET_FULFILL_TEAM_STAT_FAIL,
      payload: error.response?.data || error.message
    });
    throw error;
  }
};

export const orderAction = {
  getOrders,
  updateOrders,
  getSaleTeamStatus,
  getFulfillTeamStat
};
